import bannerImg from './banners/woman-helping-man-gym.jpg';


export default {
    id: 'anamnese',
    title: 'Ficha de anamnese',
    description: 'Colete objetivos, histórico físico e nível de experiência dos seus alunos antes de iniciar o treino.',
    indicatedFor: 'Personal trainers',
    stepsCount: 2,
    questionsSummary: ['Objetivo principal', 'Peso atual', 'Experiência com treino'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Ficha de anamnese',
        active: false,
        allow_multiple_answers: true,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Objetivos',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'text',
                        label: 'Qual é o seu principal objetivo?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'weight',
                        label: 'Qual é o seu peso atual?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                ],
            },
            {
                order: 2,
                title: 'Estágio atual',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Continuar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: 'Qual é a sua experiência com treino?',
                        description: null,
                        required: true,
                        settings: {
                            max: 5,
                            min: 1,
                            maxLabel: 'Avançado',
                            minLabel: 'Iniciante',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
};
